import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest, } from '../_helpers/apiConfig';
import {toast} from "react-toastify";


export const getAllPaymentList = createAsyncThunk("/adminApi/transitionList", async (filters) => {
    const response = await apiRequest('POST', '/v1/adminApi/transitionList', filters);
    return response;
});

export const getAllPaymentListById = createAsyncThunk("/adminApi/transitionListById", async (filters) => {
    const response = await apiRequest('POST', '/v1/adminApi/transitionList', filters);
    return response;
});


export const getMyWalletTransactionsData = createAsyncThunk("/user/getMyWalletTransactionsData", async (filters) => {
    const response = await apiRequest('POST', '/v1/user/getMyWalletTransactionsData', filters);
    return response;
});




export const refundtnx = createAsyncThunk(
    "/adminApi/refundtnx",
    async (filters, thunkAPI) => {
      const response = await apiRequest("POST", "/v1/adminApi/refundtnx", filters);
      
      if (response) {
        thunkAPI.dispatch(getAllPaymentList(filters.filter)); // Ensure correct usage
      }
      toast.info(response?.message || "success");
      return response;
    }
  );






const paymentAndTransactionSlice = createSlice({
    name: 'community',
    initialState: {
        paymentsAndTransaction: [],
        totalpaymentsAndTransaction: null,
        grosspaymentsAndTransaction: 0,
        netpaymentsAndTransaction: 0,
        userTnxList: [],
        userTnxTotal: null,
        userWalletTnxList: [],
        userWalletTnxListTotal: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllPaymentList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllPaymentList.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentsAndTransaction = action?.payload?.data?.list;
                state.totalpaymentsAndTransaction = action?.payload?.data?.total;
                state.grosspaymentsAndTransaction = action?.payload?.data?.gross;
                state.netpaymentsAndTransaction = action?.payload?.data?.net;

            })
            .addCase(getAllPaymentList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(getAllPaymentListById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllPaymentListById.fulfilled, (state, action) => {
                state.loading = false;
                state.userTnxList = action?.payload?.data?.list;
                state.userTnxTotal = action?.payload?.data?.total;

            })
            .addCase(getAllPaymentListById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(getMyWalletTransactionsData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMyWalletTransactionsData.fulfilled, (state, action) => {
                state.loading = false;
                state.userWalletTnxList = action?.payload?.data?.transactionIds || 0;
                state.userWalletTnxListTotal = action?.payload?.data?.transactionIds?.length || 0;

            })
            .addCase(getMyWalletTransactionsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })


            .addCase(refundtnx.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(refundtnx.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(refundtnx.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })






    },
});

export default paymentAndTransactionSlice.reducer;